import * as React from 'react';

import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';

import { withHomePageSection } from 'components/withHomePageSection';
import ExpandCollapsePanel from 'shared/SchedulePage/ExpandCollapsePanel';
import { fromScreen } from 'utils/media-query/responsive.util';

import { Typography } from '../../../components/DesignSystemV2/Typography';
import { colorsV2 } from '../../../style/colors-v2';

/* eslint-disable react/prop-types */
const CourseFAQWrapper = styled.div`
  display: grid;
  grid-row-gap: 32px;
  .faq-section {
    color: ${colorsV2.black100};
    .expand-collapse-panel {
      background: ${colorsV2.gray5};
      border: 1px solid ${colorsV2.gray20};
      &.expanded {
        background: ${colorsV2.white100};
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .txt-description {
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: 0px;
    text-align: left;
  }
`;

const FAQGroup = styled.div`
  display: grid;
  grid-row-gap: 24px;

  .panel-content {
    word-break: break-word;
  }
`;

const HeadingContainer = styled.div`
  .title {
    margin-bottom: 16px;
  }
  .landing-title {
    margin-bottom: 24px;
  }

  ${fromScreen(776)} {
    .title {
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 24px;
    }
    .landing-title {
      margin-bottom: 40px;
    }
  }

  ${fromScreen(1144)} {
    .landing-title {
      text-align: center;
    }
  }
`;

const Main = styled.div``;

const Container740 = styled.div`
  ${fromScreen(776)} {
    padding-bottom: 32px;
  }
  ${fromScreen(1144)} {
    position: relative;
  }
`;

// FAQs by class group

const staticQueryFaqs = graphql`
  query {
    allFaqs: allGoogleSpreadsheetDolLandingPageFaQs(
      filter: { status: { eq: "on" } }
    ) {
      group(field: groupClass) {
        fieldValue
        nodes {
          groupClass
          question
          content
        }
      }
    }
  }
`;

export const CourseFAQByClassGroup = ({ classGroup }) => {
  const queryData = useStaticQuery(staticQueryFaqs);
  const data = queryData.allFaqs.group.find(x => x.fieldValue === classGroup);
  const [expandIndex, setExpandIndex] = React.useState(1);
  return (
    <CourseFAQWrapper>
      {data && (
        <FAQGroup>
          {data.nodes.map((faq, idx) => {
            const id = idx + 1;
            const { question, content } = faq;
            return (
              <div className="faq-section" key={id}>
                <ExpandCollapsePanel
                  onExpandCollapseClick={() => {
                    setExpandIndex(prevExpandIndex => {
                      if (prevExpandIndex === id) return -1;
                      return id;
                    });
                  }}
                  expanded={expandIndex === id}
                  title={question}
                >
                  <p
                    style={{ whiteSpace: 'pre-wrap' }}
                    dangerouslySetInnerHTML={{
                      __html: content
                    }}
                  />
                </ExpandCollapsePanel>
              </div>
            );
          })}
        </FAQGroup>
      )}
    </CourseFAQWrapper>
  );
};

export const CourseFAQSectionByClassGroup = props => {
  const courseDetailTitle = {
    variant: 'bold/20-28',
    desktopVariant: 'bold/24-32',
    className: 'title'
  };

  return (
    <Main {...props}>
      <HeadingContainer>
        <Typography
          {...courseDetailTitle}
          v3
          as="h2"
        >{`Các câu hỏi thường gặp`}</Typography>
      </HeadingContainer>
      <CourseFAQByClassGroup classGroup={props.classGroup} />
    </Main>
  );
};

export const FAQByClassGroup = withHomePageSection(
  ({ classGroup }) => (
    <Container740 id="faq-section">
      <CourseFAQSectionByClassGroup classGroup={classGroup} />
    </Container740>
  ),
  { selfish: true }
);
